import { Optional } from '@/common/domain/Optional';

export const toArrayToUpdate = <U, T>(oldValues: T[], uiValues: U[], toDomain: (ui: U) => T): Optional<T[]> =>
  JSON.stringify(uiValues).localeCompare(JSON.stringify(oldValues)) !== 0 ? Optional.of(uiValues.map(toDomain)) : Optional.empty();
